import React, { useEffect, useCallback, useState} from 'react';
import RecordInfo from "components/upload/RecordInfo.js";
import Discogs from "discogs/Discogs.js";
import Waveform from "components/Waveform.js"
import AudioUnit from "engine/audio.js"
import {connect} from 'react-redux';

const discogs = new Discogs();

const SampleOption = ({sample, id, store, isSaved}) => { 
    let [audioUnit, setAudioUnit] = useState(undefined);
    let [records, setRecords] = useState([]);

    useEffect(() => {
        let audioUnit = new AudioUnit();
        audioUnit.setBuffer(sample.audioBuffer);
        setAudioUnit(audioUnit);
    }, [sample, setAudioUnit]);

    useEffect(() => {
        discogs.searchRecords(sample.name.replace(".wav", "").replace(".flac", ""))
            .then((r) => {
                setRecords(r);
            });
    }, [sample, setRecords]);

    if (!audioUnit) { return []; };
    return (
        <div className="sample-option">
          <div className="sample-name">
            {sample.name}
            {isSaved ? <span className="checkmark">&#10003;</span> : ''}
          </div>
          <div className="wave-and-thumb">
        <Waveform
          store={store}
          buffer={sample.audioBuffer}
          id={id}
          audioUnit={audioUnit}
          sample={sample}/>
            <RecordInfo sample={sample} discogs={discogs} records={records}/>
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SampleOption);
